import React from "react";
import { Button, Table, Modal } from "react-bootstrap";

const UnknownLabel = "Не определено";

const ModalTable = (props) => {
	return (
		<Modal show={props.show} onHide={props.onHide} bsSize="large">
			<Modal.Header closeButton>
				<Modal.Title>{props.title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Table>
					<colgroup>
						<col />
						<col width="40" />
					</colgroup>
					<thead>
					<tr>
						{props.titles.map((title, index) => <th key={index}>{title}</th>)}
					</tr>
					</thead>
					<tbody>
					{props.data.map((item, index) =>
						<tr key={index}>
							<td>{item.name || UnknownLabel}</td>
							<td>{item.count}</td>
						</tr>
					)}
					</tbody>
				</Table>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={props.onHide}>Закрыть</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ModalTable;
